document.addEventListener('DOMContentLoaded', () => {
    const productCards = document.querySelectorAll('.byob-product-col');
    const countEl = document.getElementById('byob-selected-count');
    const progressEl = document.getElementById('byob-progress');
    const addBtn = document.getElementById('byob-add-to-cart');
    const comparePriceEl = document.getElementById('byob-compare-price');
    const finalPriceEl = document.getElementById('byob-final-price');
    const selectedImageBoxes = document.querySelectorAll('.byob-selected-image');
    const bundleTabs = document.querySelectorAll('.byob-bundle-tab');
    const imageContainer = document.querySelector('.byob-selection-image');

    let selectedVariants = [];
    const activeTab = document.querySelector('.byob-bundle-tab.active');
    let currentBundleCount = Number(activeTab.dataset.count);
    let currentBundlePrice = Number(activeTab.dataset.price);

    productCards.forEach(card => {
        if (card.dataset.available === 'false') {
            card.classList.add('sold-out');

            const btn = card.querySelector('.add-to-cart-byob');
            if (btn) {
                btn.innerText = 'Sold Out';
                btn.disabled = true;
            }
        }
    });

    function formatPrice(price) {
        return '₹' + Number(price).toLocaleString('en-IN');
    }

    function resetSelections() {
        selectedVariants = [];
        productCards.forEach(card => {
            card.classList.remove('is-selected');
            const btn = card.querySelector('.add-to-cart-byob');
            if (btn && card.dataset.available !== 'false') {
                btn.innerText = 'Add to Cart';
            }
        });
        updateUI();
    }

    function updateSelectedImages() {
        selectedImageBoxes.forEach((box, index) => {
            box.innerHTML = '';
            if (index < currentBundleCount) {
                box.style.display = 'flex';
            } else {
                box.style.display = 'none';
            }
        });

        selectedVariants.forEach((product, index) => {
            if (selectedImageBoxes[index]) {
                selectedImageBoxes[index].innerHTML = `
                    <div class="byob-selected-item">
                        <img src="${product.image}" alt="">
                        <button class="byob-remove-product" data-id="${product.id}">-</button>
                    </div>
                `;
            }
        });

        if (currentBundleCount >= 6) {
            imageContainer.classList.add('compact');
        } else {
            imageContainer.classList.remove('compact');
        }
    }

    function updatePrices() {
        let totalComparePrice = 0;
        selectedVariants.forEach(product => {
            totalComparePrice += Number(product.comparePrice || 0);
        });

        const comparePrice = totalComparePrice / 100;
        let finalPrice = comparePrice;

        if (selectedVariants.length === currentBundleCount) {
            finalPrice = currentBundlePrice;
        }

        comparePriceEl.innerHTML = `
            <span style="text-decoration: line-through;">
                ${formatPrice(comparePrice)}
            </span>
        `;

        finalPriceEl.innerHTML = `
            <span>${formatPrice(finalPrice)}</span>
        `;
    }

    function updateUI() {
        countEl.textContent = selectedVariants.length;
        progressEl.style.width = ((selectedVariants.length / currentBundleCount) * 100) + '%';
        addBtn.disabled = selectedVariants.length !== currentBundleCount;

        document.querySelector('.byob-selection-status').innerHTML = `
            <span id="byob-selected-count">
                ${selectedVariants.length}
            </span>/${currentBundleCount} Selected
        `;

        updateSelectedImages();

        document.querySelectorAll('.byob-remove-product').forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.stopPropagation();
                const variantId = btn.dataset.id;

                selectedVariants = selectedVariants.filter(
                    item => item.id !== variantId
                );

                document.querySelectorAll('.byob-product-col').forEach(card => {
                    if (card.dataset.variantId === variantId) {
                        card.classList.remove('is-selected');
                        const cartBtn = card.querySelector('.add-to-cart-byob');
                        if (cartBtn) {
                            cartBtn.innerText = 'Add to Cart';
                        }
                    }
                });
                updateUI();
            });
        });
        updatePrices();
    }

    bundleTabs.forEach(tab => {
        tab.addEventListener('click', () => {
            bundleTabs.forEach(btn =>
                btn.classList.remove('active')
            );

            tab.classList.add('active');
            currentBundleCount = Number(tab.dataset.count);
            currentBundlePrice = Number(tab.dataset.price);

            resetSelections();
        });
    });

    productCards.forEach(card => {
        card.addEventListener('click', () => {
            if (card.dataset.available === 'false') {
                return;
            }
            const variantId = card.dataset.variantId;
            const image = card.dataset.image;
            const price = Number(card.dataset.price);
            const comparePrice = Number(card.dataset.comparePrice);

            if (!variantId) {
                alert('Variant ID Missing');
                return;
            }

            const btn = card.querySelector('.add-to-cart-byob');
            if (card.classList.contains('is-selected')) {
                card.classList.remove('is-selected');
                btn.innerText = 'Add to Cart';
                selectedVariants = selectedVariants.filter(
                    item => item.id !== variantId
                );
            } else {
                if (selectedVariants.length >= currentBundleCount) {
                    alert(`You can select only ${currentBundleCount} products`);
                    return;
                }

                card.classList.add('is-selected');
                btn.innerText = 'Remove From Cart';
                selectedVariants.push({
                    id: variantId,
                    image,
                    price,
                    comparePrice
                });

                if (selectedVariants.length === currentBundleCount) {
                    confetti({
                        particleCount: 150,
                        angle: 60,
                        spread: 80,
                        origin: { x: 0, y: 0.7 }
                    });

                    confetti({
                        particleCount: 150,
                        angle: 120,
                        spread: 80,
                        origin: { x: 1, y: 0.7 }
                    });
                }
            }
            updateUI();
        });
    });

    addBtn.addEventListener('click', async () => {
        if (selectedVariants.length !== currentBundleCount) {
            alert(`Please select ${currentBundleCount} products`);
            return;
        }

        try {
            addBtn.disabled = true;
            addBtn.innerHTML = 'Adding Products...';

            await fetch('/cart/clear.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            const items = selectedVariants.map(item => ({
                id: Number(item.id),
                quantity: 1
            }));

            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({ items })
            });

            if (!response.ok) {
                const err = await response.json().catch(() => ({}));
                throw new Error(err.description || 'Add To Cart Failed');
            }

            window.location.href = '/cart';

        } catch (error) {
            console.error(error);
            alert(error.message || 'Something went wrong. Please try again.');
            addBtn.disabled = false;
            addBtn.innerHTML = 'Add to Cart';
        }
    });

    const searchInput = document.querySelector('.byob-search');
    const productContainer = document.querySelector('.byob-main');

    document.querySelectorAll('.byob-product-col').forEach((card, index) => {
        card.dataset.originalIndex = index;
    });

    function debounce(func, delay = 300) {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    }

    const handleSearch = debounce((searchValue) => {
        const cards = [...document.querySelectorAll('.byob-product-col')];
        const keyword = searchValue.toLowerCase().trim();
        if (!keyword) {
            cards.sort((a, b) => {
                return (Number(a.dataset.originalIndex) - Number(b.dataset.originalIndex));
            });
            cards.forEach(card => {
                card.style.display = '';
                productContainer.appendChild(card);
            });
            const noResult = document.querySelector('.search-empty');
            if (noResult) {
                noResult.remove();
            }
            return;
        }
        const matched = [];
        const unmatched = [];
        cards.forEach(card => {
            const title = card.querySelector('.byob-product-title')?.innerText.toLowerCase() || '';
            if (title.includes(keyword)) {
                matched.push(card);
            } else {
                unmatched.push(card);
            }
        });

        const oldMessage = document.querySelector('.search-empty');
        if (oldMessage) {
            oldMessage.remove();
        }

        [...matched, ...unmatched].forEach(card => {
            productContainer.appendChild(card);
        });

        matched.forEach(card => {
            card.style.display = '';
        });

        unmatched.forEach(card => {
            card.style.display = '';
        });

        if (matched.length === 0) {
            const empty = document.createElement('p');
            empty.className = 'search-empty';
            empty.innerText = 'No products found';
            productContainer.appendChild(empty);
        }
    }, 300);

    if (searchInput) {
        searchInput.addEventListener('input', function (e) {
            handleSearch(e.target.value);
        });
    }

    const showMoreBtn = document.getElementById('byob-show-more');
    let visibleCount = 20;
    const loadCount = 20;

    productCards.forEach((card, index) => {
        if (index >= visibleCount) {
            card.classList.add('hidden-product');
        }
    });

    function loadProducts() {
        const hiddenProducts = document.querySelectorAll(
            '.byob-product-col.hidden-product'
        );
        for (let i = 0; i < loadCount; i++) {
            if (hiddenProducts[i]) {
                hiddenProducts[i].classList.remove('hidden-product');
            }
        }

        const remainingProducts = document.querySelectorAll(
            '.byob-product-col.hidden-product'
        );

        if (!remainingProducts.length && showMoreBtn) {
            showMoreBtn.style.display = 'none';
        }
    }

    if (showMoreBtn) {
        showMoreBtn.addEventListener('click', loadProducts);
    }

    window.addEventListener('scroll', () => {
        if (!showMoreBtn) return;

        const rect = showMoreBtn.getBoundingClientRect();
        if (rect.top <= window.innerHeight + 100 && showMoreBtn.style.display !== 'none') {
            loadProducts();
        }
    });

    updateUI();
});